import { v4 as generateID } from '@lukeed/uuid';
const { parse, stringify } = JSON;
export function setIDs(peaks, options = {}) {
    const output = (options.output || parse(stringify(peaks)));
    for (const peak of output) {
        peak.id = generateID();
    }
    return output;
}
//# sourceMappingURL=setIDs.js.map